import { sanitizeGeoJsonForMercator } from "./sanitize-geojson-mercator";

const cache = new Map<string, Promise<any | null>>();

/**
 * Fetch + sanitize GeoJSON once per URL (shared across map overlays + place legend).
 * Avoids re-parsing multi‑MB world datasets on every country navigation.
 */
export function loadSanitizedGeoJson(url: string): Promise<any | null> {
  let pending = cache.get(url);
  if (!pending) {
    pending = fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`GeoJSON ${url}: ${r.status}`);
        return r.json();
      })
      .then((json) => sanitizeGeoJsonForMercator(json))
      .catch(() => null);
    cache.set(url, pending);
  }
  return pending;
}

export const GEOJSON_URL = {
  countries: "/data/world-countries.geojson",
  countriesDetail: "/data/world-countries-detail.geojson",
  regions: "/data/world-regions.geojson",
} as const;
